// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2u9JG","title":"Info_title__2LsEh","selects":"Info_selects__2RhNA","requiredAsterisk":"Info_requiredAsterisk__2N_jv"};